/** 보정 운영 GNB/라우트 접근 역할 */
export const CALIBRATION_ACCESS_ROLES = ['super_admin', 'admin', 'calibration_operator'];

/** 일반 관리자 메뉴 (보정 전용 담당자 제외) — 회원조회 등 */
export const GENERAL_ADMIN_ROLES = ['super_admin', 'admin', 'manager', 'operator'];

/**
 * 보정 화면에서 회원 식별정보(이름·로그인 ID) 표시 여부.
 * 백엔드 `admin.calibration.pii.view` + 회원조회(`admin.user.view`)와 동일 취지:
 * 보정만 담당하는 역할은 케이스 ID만 본다.
 */
export const canViewCalibrationMemberInfo = (role) =>
  GENERAL_ADMIN_ROLES.includes(role) && CALIBRATION_ACCESS_ROLES.includes(role);

export const userIdxToCaseId = (userIdx) => {
  const n = Number(userIdx);
  if (!Number.isFinite(n) || n <= 0) return '';
  return `CAL-${String(n).padStart(6, '0')}`;
};

export const caseIdToUserIdx = (caseId) => {
  if (!caseId || typeof caseId !== 'string') return null;
  const match = caseId.toUpperCase().match(/^CAL-(\d+)$/);
  if (!match) return null;
  const n = parseInt(match[1], 10);
  return n > 0 ? n : null;
};

export const CALIBRATION_STATUS_LABEL = {
  in_progress: '보정 진행 중',
  pending_model: '모델 업로드 필요',
  waiting: '대기',
  complete: '완료',
};

export const CALIBRATION_PHASE_LABEL = {
  not_started: '미시작',
  day1_in_progress: '1일차 진행',
  day1_complete: '1일차 완료',
  day2_in_progress: '2일차 진행',
  day2_complete: '2일차 완료',
  day3_in_progress: '3일차 진행',
  calibration_complete: '보정 완료',
};
